import React from 'react';
import styled from 'styled-components';
import 'react-day-picker/dist/style.css';

interface CustomTableProps {
  tableHeader: string[];
  renderTableItem: () => JSX.Element;
  type?: string;
}

const CustomTable: React.FC<CustomTableProps> = ({ tableHeader, renderTableItem, type }) => {
  const tableClassName =
    type === 'noneborder' ? 'nonborder' : type === 'radius' ? 'radiusTable' : 'normalTable';
  return (
    <Style>
      <table className={tableClassName}>
        <thead>
          <tr>
            {tableHeader.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>{renderTableItem()}</tbody>
      </table>
    </Style>
  );
};

export default CustomTable;

const Style = styled.div`
  table,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid #eaecf0;
  }
  td,
  th {
    padding: 12px;
  }
  table {
    width: 100%;
  }
  th {
    background: #f9fafb;
    color: #212329;
  }
  td {
    color: #000;
    font-size: 14px;
  }
  .radiusTable {
    border-collapse: collapse;
    border-radius: 5px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #e3e3e3;

    button {
      padding: 7px 20px;
      background: none;
      border: 1px solid #d6d6d6;
      border-radius: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    thead th {
      background: #f7f7f7;
      border: none;
      border-bottom: 1px solid #e3e3e3;
      padding: 8px;
      font-weight: 600;
    }
    thead th:nth-child(1) {
      border-top-left-radius: 5px;
    }
    thead th:last-child {
      border-top-right-radius: 5px;
    }
    tbody td {
      padding: 14px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .nonborder {
    border-collapse: collapse;
    border-radius: 5px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #e3e3e3;

    button {
      padding: 7px 20px;
      background: none;
      border: 1px solid #d6d6d6;
      border-radius: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    thead th {
      background: #f7f7f7;
      border: none;
      border-bottom: 1px solid #e3e3e3;
      font-weight: 600;
    }
    thead th:nth-child(1) {
      border-radius: 5px;
    }
    thead th:nth-child(5) {
      border-radius: 5px;
    }
    tbody td {
      padding: 18px 0;
      border: none;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
`;
